import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-following',
  templateUrl: './user-following.component.html',
  styleUrls: ['./user-following.component.scss']
})
export class UserFollowingComponent implements OnInit {

      public currentPage = 1; 
   public categories : any
  public totalItems = 0;
public articleDetails: any[] = [];
userDetails: any = {}; // top of your component

  constructor( private apisService: ApisService,
          private route: ActivatedRoute,
         private loading : LoadingService,
        private toastr : ToastrService,
        private translate: TranslateService
      ) { }

    ngOnInit(): void {
 const articleId = this.route.snapshot.paramMap.get('id');
  if (articleId) {
    this.getUserFollowing(articleId);
  }
      // this.postCountires();
  }

 

getUserFollowing(id: any) {
  this.apisService.getUserFollowing(id).subscribe({
    next: (res) => {
      this.articleDetails = res.data.following;
            this.userDetails = res.data.user; // ✅ store user object

      console.log(this.articleDetails);
      this.loading.hide();
    },
    error: (err) => {
      console.log('error in fetching article details', err);
  this.translate.get(['MENU.DASHBOARD.ERROR', 'MENU.DASHBOARD.UNEXPECTED_ERROR']).subscribe(translations => {
    this.toastr.error(translations['MENU.DASHBOARD.UNEXPECTED_ERROR'], translations['MENU.DASHBOARD.ERROR']);
  });      this.loading.hide();
    }
  });
}


    /*----------  Handling image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }

 
}
